
(function ($) {
    $.fn.dropdown = function () {
        return this.each(function () {
            var dd, trigger, menu;
            dd = $(this);
            trigger = dd.find('.dropdown-trigger');
            menu = dd.find('.dropdown-menu');

            var options = dd.data('options');

            var defaults = {
                "ajax": false,
                "displayActive": false
            };

            var opts = $.extend({}, defaults, options);

            trigger.bind('click', function (e) {
                e.preventDefault();
                $('.dropdown').not(dd).toggleClass('open',false);
                dd.toggleClass('open');
            });

            menu.find('a').bind('click', function (e) {
                if (opts.ajax) e.preventDefault();
                var link = $(this);
                dd.toggleClass('open', false);

                if (opts.displayActive) {
                    menu.find('.active').toggleClass('active', false);
                    link.parent().toggleClass('active', true);
                    trigger.html(link.text() + ' <i class="far fa-sort-amount-down"></i>');
                }

            });

            $(document).bind('click', function (e) {
                if (!dd.hasClass('open')) return;
                if ($(e.target) != dd && $(e.target).closest('.dropdown').length === 0) {
                    dd.toggleClass('open', false);
                }
            });
        });
    };
})(jQuery);